import { FC } from 'react'
import { useSelector } from 'react-redux'

import { DateTimePicker } from 'components/Forms'
import { Alert, AlertVariant, Dropdown } from 'ui'

import { t } from 'translations'

type Props = {
  day: MData.Day
  type: MData.Day['availabilities'][number]['type']
  timeSlotIndex: number
  handleDelete: () => void
  setFieldValue: (field: string, value: unknown) => void
}

const AvailabilityTime: FC<Props> = ({ day: { dayOfWeek, availabilities = [] }, type, timeSlotIndex, handleDelete, setFieldValue }) => {
  const { enablePreferredRanges } = useSelector((state: MStore.RootState) => state.settings)

  const typeColors = { AVAILABLE: 'success', UNAVAILABLE: 'danger', PREFERRED: 'warning' }

  const variant = typeColors[type] as AlertVariant

  return (
    <Alert id={`availability-item-${dayOfWeek}-time-${timeSlotIndex}`} variant={variant} className={`mb-xl-2`} data-cy="availabilities-range-alert" noIcon>
      <div>
        <Dropdown.Toggle color="secondary" size="small" className="position-absolute right-0 top-0 m-2" outlined data-cy="availability-type-dropdown-button" />
        <Dropdown.Menu>
          {[enablePreferredRanges ? 'PREFERRED' : null, 'AVAILABLE', 'UNAVAILABLE'].filter(Boolean).map(option => {
            if (type === option) return null
            return (
              <Dropdown.Item
                key={option}
                onClick={() => setFieldValue(`days.${dayOfWeek}.availabilities.${timeSlotIndex}.type`, option)}
                data-cy={`dropdown-item-${option}`}
              >
                {t(`employee.availabilityForm.SET_${option}`)}
              </Dropdown.Item>
            )
          })}
          {/* Delete availability time */}
          <Dropdown.Item onClick={handleDelete} data-cy={`dropdown-item-delete`}>
            {t('actions.DELETE')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </div>

      <div className="mb-2 text-left">
        {availabilities[timeSlotIndex]?.start > availabilities[timeSlotIndex]?.end ? <i className="fas fa-moon mr-1" /> : null}
        <Alert.Icon variant={variant} className="mr-2" />
        {t(`employee.availabilityForm.${type}`)}
      </div>
      <div className="d-flex align-items-center justify-content-center flex-xl-column">
        <DateTimePicker
          module="employee.availabilityForm"
          translation="availabilityStart"
          type="time"
          name={`days.${dayOfWeek}.availabilities.${timeSlotIndex}.start`}
          formGroupStyle="mb-1 mr-1 mr-lg-0"
          hideLabel
          hideDescription
          required
        />
        <DateTimePicker
          module="employee.availabilityForm"
          translation="availabilityEnd"
          type="time"
          name={`days.${dayOfWeek}.availabilities.${timeSlotIndex}.end`}
          formGroupStyle="mb-1"
          hideLabel
          hideDescription
          required
        />
      </div>
    </Alert>
  )
}
export default AvailabilityTime
